/* unplugin-vue-components disabled */import { render } from "./AdminListPeriodicReviews.vue?vue&type=template&id=67945e37&scoped=true&ts=true"
import script from "./AdminListPeriodicReviews.vue?vue&type=script&lang=ts"
export * from "./AdminListPeriodicReviews.vue?vue&type=script&lang=ts"

import "./AdminListPeriodicReviews.vue?vue&type=style&index=0&id=67945e37&scoped=true&lang=scss"
import "./AdminListPeriodicReviews.vue?vue&type=style&index=1&id=67945e37&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67945e37"]])

export default __exports__